import { Fragment } from 'react';

import { settingsIntegrationsCardsCustomRoutes } from './views/custom';
import { settingsIntegrationsCardsMagentoRoutes } from './views/magento';
import { settingsIntegrationsCardsSalesforceRoutes } from './views/salesforce';
import { settingsIntegrationsCardsShopifyRoutes } from './views/shopify';

export const settingsIntegrationsCardsRoutes = (
  <Fragment>
    {settingsIntegrationsCardsCustomRoutes}
    {settingsIntegrationsCardsShopifyRoutes}
    {settingsIntegrationsCardsMagentoRoutes}
    {settingsIntegrationsCardsSalesforceRoutes}
  </Fragment>
);
